/** Product page helpers: <huna-gallery> swaps photos from the thumbnails; <huna-sticky-buy> shows whenever the main button is off screen (not over the CTA or footer). */
class HunaGallery extends HTMLElement {
  connectedCallback() {
    this.figs = [...this.querySelectorAll('.huna-pdp__fig')];
    this.thumbs = [...this.querySelectorAll('.huna-pdp__thumb')];
    if (this.thumbs.length < 2 || this.thumbs.length !== this.figs.length || 'enhanced' in this.dataset) return;
    this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.show(i)));
    this.dataset.enhanced = '';
    this.show(0);
  }

  show(i) {
    this.figs.forEach((f, n) => (f.hidden = n !== i));
    this.thumbs.forEach((t, n) => t.setAttribute('aria-pressed', n === i));
  }
}

class HunaStickyBuy extends HTMLElement {
  connectedCallback() {
    const targets = [...document.querySelectorAll(this.dataset.watch)];
    if (!targets.length || 'enhanced' in this.dataset) return;
    this.dataset.enhanced = '';
    // Shown whenever the main button is off screen (also before it is reached on a phone), and hidden while the button,
    // the final call to action or the footer is in view, so it never covers them.
    const seen = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
      this.classList.toggle('is-visible', seen.size === 0);
    });
    targets.forEach((t) => io.observe(t));
  }
}

if (!customElements.get('huna-gallery')) customElements.define('huna-gallery', HunaGallery);
if (!customElements.get('huna-sticky-buy')) customElements.define('huna-sticky-buy', HunaStickyBuy);
